import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Two pages in one:
 *  - "not found" (the ** route): an address that matches no page. Shows the
 *    address that was asked for, so a broken link is easy to report.
 *  - "something went wrong" (/error, optionally with a message in the
 *    navigation state).
 */
@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  notFound = false;
  errorMessage = 'Something went wrong on our side. Please try again in a moment.';
  requested = '';
  canGoBack = false;

  constructor(private router: Router, private route: ActivatedRoute, private location: Location) {}

  ngOnInit(): void {
    this.notFound = this.route.snapshot.data['kind'] === 'not-found';
    const message = this.router.getCurrentNavigation()?.extras?.state?.['error'];
    if (typeof message === 'string' && message.trim()) {
      this.errorMessage = message;
    }
    // The address without its query (it can hold a one-time token).
    this.requested = window.location.pathname;
    this.canGoBack = window.history.length > 1;
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  goBack(): void {
    this.location.back();
  }

  reload(): void {
    window.location.reload();
  }
}
